




























import { Prop, Component, Vue } from "vue-property-decorator";

@Component
export default class InputText extends Vue {
  @Prop({ type: String, required: true }) type!: string;
  @Prop({ type: String, required: false }) id!: string;
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: String, required: true }) value!: string;
  @Prop({ type: String, required: false }) error!: string;
  @Prop({ type: String, required: false }) placeholder!: string;
  @Prop({ type: Boolean, required: false }) hasIcon!: string;
  @Prop({ type: Boolean, required: false }) hasSuffix!: string;
  @Prop({ type: Number, required: false }) min!: number;
  @Prop({ type: Boolean, required: false, default: false }) disabled!: boolean;
  @Prop({ type: Number, required: false }) maxlenght!: number;

  updateValue(e: any) {
    this.$emit("input", e.target.value);
  }

  focus(e: any) {
    this.$emit("focus", e);
  }

  blur(e: any) {
    this.$emit("blur", e);
  }
}
